// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/helicopter-wake.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/helicopter-wake/helicopter-wake.js';

mount([g0]);
